export default function () {
  document.querySelectorAll('details[data-faq-id]').forEach((el) => {
    el.addEventListener('toggle', () => {
      if ((el as HTMLDetailsElement).open) {
        window.mixpanel.track('faq_open', {
          faq_id: (el as HTMLElement).dataset['faq-id'],
        })
      }
    })
  })
}
